export default __webpack_public_path__ + "static/media/noReport.118954e5.svg";